import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Options } from './multiselect-dropdown.types';
import { DropdownComponent } from '../dropdown.component';

@Component({
  selector: 'mpro-multiselect-dropdown',
  templateUrl: './multiselect-dropdown.component.html',
  styleUrls: ['./multiselect-dropdown.component.scss'],
})
export class MultiSelectDropdownComponent implements OnInit {
  @ViewChild(DropdownComponent) public dropdown: DropdownComponent;

  @Input() public inputValues: string[];

  @Input() public nameProperty: string = 'name';
  @Input() public options: Options[] = [];
  @Input() public title: string;
  @Input() public disabled: boolean = false;
  @Input() public horizontal: boolean = false;

  @Output() public selectionChanged: EventEmitter<string[]> =
    new EventEmitter();

  public ngOnInit(): void {}

  private resetValue() {
    this.inputValues = [];
  }

  public isValueSelected(inputValue: string) {
    return (
      this.inputValues.includes(inputValue) ||
      (this.inputValues.length === 0 && inputValue === this.options[0].value)
    );
  }

  public onSelect(selected: Options) {
    if (selected.value === this.options[0].value) {
      this.resetValue();
      return this.selectionChanged.emit(this.inputValues);
    }
    if (!this.inputValues.includes(selected[this.nameProperty])) {
      this.inputValues.push(selected[this.nameProperty]);
    } else {
      this.inputValues = this.inputValues.filter(
        (value) => value !== selected[this.nameProperty]
      );
    }
    this.selectionChanged.emit(this.inputValues);
  }
}
